import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';


const toAmPm = (t) => {
  if (!t) return '';
  const [h, m] = t.split(':');
  const hr = parseInt(h);
  const ampm = hr >= 12 ? 'PM' : 'AM';
  const hr12 = hr % 12 || 12;
  return `${hr12}:${m} ${ampm}`;
};

const FALLBACK = [
  { day:'03', month:'April 2026', icon:'✝', title:'Good Friday Service', time:'', description:"A solemn service of remembrance, worship and the message of Christ's sacrifice for all humanity." },
  { day:'05', month:'April 2026', icon:'🌅', title:'Easter Sunday Celebration', time:'', description:'Celebrate the resurrection of Jesus Christ with special praise, worship, and a powerful message of hope!' },
  { day:'24', month:'May 2026', icon:'🕊️', title:'Pentecost Sunday', time:'', description:"A special service celebrating the outpouring of the Holy Spirit — the hallmark of our AG heritage." },
  { day:'25', month:'Dec 2026', icon:'🎄', title:'Christmas Service', time:'', description:'Join us for a joyful Christmas celebration — caroling, drama, and the glorious message of Emmanuel!' },
  { day:'31', month:'Dec 2026', icon:'🌟', title:'Watch Night Service', time:'', description:'End the year in prayer and worship. Welcome 2027 in the presence of God with thanksgiving.' },
  { day:'01', month:'Jan 2027', icon:'🎊', title:'New Year Service', time:'', description:'Begin the new year with a special dedication service, praise and a prophetic Word for the year ahead.' },
];

export default function Events() {
  const [events, setEvents] = useState(FALLBACK);

  useEffect(() => {
    let cancelled = false;
    supabase.from('events').select('*').order('event_date', { ascending: true })
      .then(({ data }) => {
        if (cancelled) return;
        if (data && data.length > 0) {
          setEvents(data.map(e => {
            const d = new Date(e.event_date + 'T00:00:00');
            return {
              day: isNaN(d.getTime()) ? '??' : d.getDate().toString().padStart(2, '0'),
              month: isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-IN', { month: 'long', year: 'numeric' }),
              icon: e.icon || '✝',
              time: e.event_time || '',
              title: e.title || '',
              description: e.description || '',
            };
          }));
        }
      }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <section id="events" className="section" style={{ background: 'var(--bg-deep)' }}>
      <div className="container">
        <div style={{ textAlign: 'center' }}>
          <span className="section-tag">✦ Mark Your Calendar</span>
          <h2 className="section-title">Upcoming <span>Events</span></h2>
          <div className="divider center" />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 20 }}>
          {events.map((ev, i) => (
            <div key={i} className="card fade-up" style={{ overflow: 'hidden' }}>
              <div style={{ background: 'linear-gradient(135deg,#b22222 0%,var(--primary-dark) 100%)', padding: '18px 20px', display: 'flex', alignItems: 'center', gap: 18 }}>
                <div>
                  <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'2rem', color:'#fff', lineHeight:1 }}>{ev.day}</div>
                  <div style={{ fontSize:'0.68rem', letterSpacing:'0.18em', textTransform:'uppercase', color:'rgba(255,255,255,0.85)', marginTop:4 }}>{ev.month}</div>
                  {ev.time && (
                    <div style={{ fontSize:'0.72rem', color:'rgba(255,255,255,0.9)', marginTop:5, display:'flex', alignItems:'center', gap:4 }}>
                      🕐 {toAmPm(ev.time)}
                    </div>
                  )}
                </div>
                <div style={{ fontSize:'1.6rem', marginLeft:'auto' }}>{ev.icon}</div>
              </div>
              <div style={{ padding:'20px 22px' }}>
                <h4 style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'0.82rem', color:'var(--primary)', marginBottom:8 }}>{ev.title}</h4>
                {ev.time && (
                  <div style={{ marginBottom:10, display:'flex', flexWrap:'wrap', gap:6 }}>
                    {ev.time.split(', ').filter(Boolean).map((t,i) => (
                      <span key={i} style={{ background:'rgba(201,168,76,0.12)', border:'1px solid rgba(201,168,76,0.3)', borderRadius:20, padding:'3px 10px', fontSize:'0.75rem', color:'var(--primary-light)' }}>
                        🕐 {toAmPm(t)}
                      </span>
                    ))}
                  </div>
                )}
                <p style={{ fontFamily:"'Crimson Pro',serif", fontSize:'0.95rem', color:'var(--text-muted)', lineHeight:1.6 }}>{ev.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
